import { render, staticRenderFns } from "./LgsRequirementCoste.vue?vue&type=template&id=96c1ef0c&"
import script from "./LgsRequirementCoste.vue?vue&type=script&lang=js&"
export * from "./LgsRequirementCoste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports